@if (companiesDatasource) {
    <app-server-side-grid
        [colDefs]="gridColumns"
        [datasource]="companiesDatasource"
        [appliedSort]="appliedSort"
        [noRows]="noResults()"
        [titleNoData]="'No Companies available.'"
        (cellSorting)="onSortChanged($event)"
    >
    </app-server-side-grid>
}
